import React, { useState } from "react";
import { Link } from "react-router-dom";
export default function LinkCart({
  name,
  link,
  img,
  className,
  textColor = "text-white",
}) {
  const [onCartHover, setOnCartHover] = useState(false);
  const [onLinkHover, setOnLinkHover] = useState(false);

  // Determine if this is a neighborhood inner page
  const isNeighborhoodInnerPage = link.includes("/neighborhood/");

  // Use dark text for neighborhood pages, white for overlay
  const overlayTextColor = "text-white"; // Keep overlay text white for contrast
  const labelTextColor = isNeighborhoodInnerPage
    ? "!text-gray-dark"
    : textColor;

  return (
    <>
      <Link to={link}>
        <div className={`flex flex-col ${className}`}>
          <div
            className={`relative cursor-pointer`}
            onMouseOver={() => {
              setOnCartHover(true);
            }}
            onMouseOut={() => {
              setOnCartHover(false);
            }}
          >
            <img
              src={img}
              className="w-[300px] h-[220px] md:h-[360px] object-cover"
            ></img>
            <div
              className={`absolute top-0 right-0 left-0 bottom-0 ${
                onCartHover ? "bg-background opacity-75" : ""
              } transition-all duration-300`}
            ></div>
            <div className="absolute top-0 bottom-0 left-0 right-0">
              <div
                className={`w-full h-full content-center text-center ${overlayTextColor} self-center ${
                  onCartHover ? "" : "hidden"
                }`}
              >
                {name}
              </div>
            </div>
          </div>
          <p
            className={`flex self-center gap-4 text-center cursor-pointer mt-3 ${labelTextColor}`}
            onMouseOver={() => {
              setOnLinkHover(true);
            }}
            onMouseOut={() => {
              setOnLinkHover(false);
            }}
          >
            {name}
          </p>
        </div>
      </Link>
    </>
  );
}
